import { useEffect, useRef } from "react";
import Lenis from "lenis";

const LENIS_EASING = (t: number) => 1 - Math.pow(1 - t, 4);

export function useLenis(enabled = false) {
  const lenisRef = useRef<Lenis | null>(null);

  useEffect(() => {
    if (!enabled) return;

    // Lenis 생성 전에 hash 스크롤 세팅
    const hash = window.location.hash;
    if (hash && hash.length > 1) {
      const hashTarget = document.querySelector(hash);
      if (hashTarget) {
        const header = document.querySelector(".header");
        const headerH = header instanceof HTMLElement ? header.offsetHeight : 80;
        const top = Math.max(0, hashTarget.getBoundingClientRect().top + window.scrollY - headerH);
        window.scrollTo({ top, behavior: "instant" });
      }
    }

    const lenis = new Lenis({
      autoRaf: false,
      anchors: false,
      duration: 1,
      easing: LENIS_EASING,
      smoothWheel: true,
      stopInertiaOnNavigate: true,
      touchMultiplier: 1.2,
      wheelMultiplier: 0.95,
    });

    // hash가 있으면 Lenis 내부 상태를 현재 스크롤 위치로 재동기화
    if (hash && hash.length > 1) {
      (lenis as any).reset();
    }

    // 이제 RAF 루프 시작
    const raf = (time: number) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    let rafId = requestAnimationFrame(raf);

    // 앵커 클릭 직접 핸들링 — 섹션별 정확한 스크롤 위치 계산
    const onAnchorClick = (e: MouseEvent) => {
      const anchor = (e.target as Element)?.closest?.("a[href^='#']");
      if (!anchor) return;
      const href = anchor.getAttribute("href");
      if (!href || href === "#") return;

      const target = document.querySelector(href);
      if (!target) return;

      e.preventDefault();

      const header = document.querySelector(".header");
      const headerH = header instanceof HTMLElement ? header.offsetHeight : 80;
      const top = target.getBoundingClientRect().top + window.scrollY - headerH;

      lenis.scrollTo(Math.max(0, top), {
        duration: 1,
        easing: LENIS_EASING,
      });
    };
    document.addEventListener("click", onAnchorClick);

    lenisRef.current = lenis;

    return () => {
      cancelAnimationFrame(rafId);
      document.removeEventListener("click", onAnchorClick);
      lenis.destroy();
      lenisRef.current = null;
    };
  }, [enabled]);

  return lenisRef;
}
